var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"about"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('h4',[_vm._v(_vm._s(item.dec))]),_c('p',[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }